import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { type FC, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'
import {
  ConversationMessagesContext,
  useConversationMessagesContext,
} from 'widgets/ConversationMessages/context'
import { ConversationMessagesSection } from 'widgets/ConversationMessages/ui/ConversationMessagesSection'
import { EmptyConversationsState } from 'widgets/ConversationMessages/ui/EmptryConversationsState/EmptyConversationsState'
import { SelectConversationState } from 'widgets/ConversationMessages/ui/SelectConversationState/SelectConversationState'

const ConversationMessagesContent = observer(() => {
  const { conversationStore } = useEntitiesContext()
  const store = useConversationMessagesContext()
  const { conversationId } = useParams()
  const id =
    conversationId === 'null' || conversationId === undefined ? null : Number(conversationId)
  const isNumber = typeof id === 'number'
  const isConversationNumber = typeof store.conversationOriginId === 'number'
  const isEmpty = conversationStore.isEmpty
  const hasPrevConversation = conversationStore.prevItemId !== null

  useEffect(() => {
    store.initReactions()

    return () => {
      store.resetReactions()
    }
  }, [])

  useEffect(() => {
    if (isNumber) {
      store.setConversationId(id)

      if (id !== 0) {
        store.loadConversation()
      }
    }

    return () => {
      store.resetConversationId()
      store.reset()
    }
  }, [id])
  const renderContent = () => {
    if (isConversationNumber) return <ConversationMessagesSection />
    if (!isConversationNumber && !isEmpty && hasPrevConversation) return <SelectConversationState />
    return <EmptyConversationsState />
  }

  return useMemo(renderContent, [
    store.conversationOriginId,
    isEmpty,
    isConversationNumber,
    hasPrevConversation,
  ])
})

type IConversationMessagesProps = {
  store: ConversationMessagesStore
}

export const ConversationMessages: FC<IConversationMessagesProps> = observer(
  ({ store, ...props }) => {
    return (
      <ConversationMessagesContext.Provider value={store}>
        <ConversationMessagesContent {...props} />
      </ConversationMessagesContext.Provider>
    )
  }
)
